import React from "react"
import Layout from "../components/layout"
import CsoundInstr from "../components/lib/csoundinstr"
import Components from "../components/lib/components"
import RSpline from "../components/RSpline"
import { Row, Col } from "react-bootstrap"
import { withPrefix } from "gatsby"

class IndexPage extends React.Component {
  constructor() {
    super()
    this.inst = {
      components: [
        {
          type: "panel", label: "morph", id: "morph", widgets: [
            { id: "weight", type: "fader", label: "WGT", min: 0, max: 1, step: 0.01, defval: 0.5, height: 200 },
            {
              id: "xy",
              idx: "num1",
              idy: "num2",
              type: "xy",
              label: "mix",
              minX: 0,
              maxX: 3.99,
              minY: 0,
              maxY: 3.99,
              step: 0.01,
              defval: { num1: 0.5, num2: 0.5 },
              height: 200,
            },
          ],
        },
        {
          type: "panel", label: "waves", id: "waves", widgets: [
            {
              func: this.rsfunc.bind(this),
              nr: 0,
              id: "wave0",
              vw: 86,
              vh: 32,
              defval: { waveseed_0: 10, wavesteps_0: 10 },
            },
            {
              func: this.rsfunc.bind(this),
              nr: 1,
              id: "wave1",
              vw: 86,
              vh: 32,
              defval: { waveseed_1: 11, wavesteps_1: 10 },
            },
            {
              func: this.rsfunc.bind(this),
              nr: 2,
              id: "wave2",
              vw: 86,
              vh: 32,
              defval: { waveseed_2: 12, wavesteps_2: 10 },
            },
            {
              func: this.rsfunc.bind(this),
              nr: 3,
              id: "wave3",
              vw: 86,
              vh: 32,
              defval: { waveseed_3: 13, wavesteps_3: 10 },
            },
          ],
        },
        {
          type: "panel", id: "adsrpanel", vertical: true, widgets: [
            {
              type: "adsr",
              label: "adsr1",
              id: "adsr1",
              on: true,
              defval: { adsr1_a: 0.01, adsr1_d: 0, adsr1_s: 1, adsr1_r: 0.1 },
            },
            {
              type: "adsr",
              label: "adsr2",
              id: "adsr2",
              defval: { adsr2_a: 0.01, adsr2_d: 0.10, adsr2_s: 0, adsr2_r: 0 },
            },

          ],
        },
        Components.lfo("lfox", "lfo_x",2),
        Components.lfo("lfoy", "lfo_y",2),
        {
          type: "panel", label: "master", id: "master", widgets: [
            { id: "amp", type: "fader", label: "amp", min: 0, max: 1, step: 0.01, defval: 0.6, height: 200 },
            { id: "rev", type: "fader", label: "reverb", min: 0, max: 1, step: 0.01, defval: 0.6, height: 200 },
            {
              id: "filt",
              type: "fader",
              label: "filter",
              log: true,
              min: 40,
              max: 15000,
              step: 0.01,
              defval: 10000,
              height: 200,
              size: 3,
            },
            {
              id: "ch",
              type: "fader",
              label: "rndch",
              min: 0,
              max: 1,
              step: 0.01,
              defval: 0,
              height: 200,
            },
          ],
        },
      ],
    }
    this.tunings = [
      {
        name: "blue",
        basekey: 0,
        basefreq: 8.25,
        scale: [1, 21 / 20, 10 / 9, 7 / 6, 5 / 4, 21 / 16, 7 / 5, 3 / 2, 25 / 16, 5 / 3, 7 / 4, 15 / 8],
      },
      {
        name: "overtone",
        basekey: 0,
        basefreq: 8.25,
        scale: [1, 17 / 16, 9 / 8, 19 / 16, 5 / 4, 21 / 16, 11 / 8, 3 / 2, 13 / 8, 27 / 16, 7 / 4, 15 / 8],
      },
      {
        name: "monte",
        basekey: 10,
        basefreq: 4.58333,
        scale: [1, 64 / 63, 9 / 8, 8 / 7, 7 / 6, 4 / 3, 21 / 16, 3 / 2, 32 / 21, 14 / 9, 16 / 9, 7 / 4],
      },
    ]
    this.csoundInstr = React.createRef()
    this.rsp = []
    for (let i = 0; i < 4; i++)
      this.rsp.push(React.createRef())
  }

  rsfunc(component, changeFunc) {
    return (
      <RSpline ref={ref => this.rsp[component.nr].current = ref} cs={this.csoundInstr.current} def={component}
               key={component.id} onChange={changeFunc} />
    )
  }

  onStart() {
    console.log("index on start")
    this.rsp.forEach(rsp => rsp.current.onStart())
  }

  render() {
    return (
      <Layout>
        <Col>
          <Row><Col><h2>Random Spline Waves</h2></Col></Row>
          <Row><Col> <CsoundInstr onStart={this.onStart.bind(this)} ref={ref => this.csoundInstr.current = ref}
                                  csoundwasm={withPrefix("csound.esm.js")} inst={this.inst} keyboard="rsw" osc="rsw"
                                  csd={withPrefix("rspline.csd")} plugins={[]} tunings={this.tunings} /></Col></Row>
        </Col>
      </Layout>
    )
  }
}

export default IndexPage
